import colors from '@/theme/colors';
import { darken, styled } from '@mui/system';
import { css, cx } from '@emotion/css';
import { forwardRef } from 'react';
import { ButtonBase, ButtonBaseProps } from './ButtonBase';
import {
  ButtonFlatSmallStyles,
  ButtonFlatMediumStyles,
  ButtonFlatLargeStyles,
  ButtonFlatSmallEmphasizedStyles,
  ButtonFlatMediumEmphasizedStyles,
} from './Buttons.styles';

export const ButtonFlat = forwardRef<HTMLButtonElement, ButtonBaseProps>(
  (
    {
      children,
      className,
      background = 'transparent',
      fontColor = colors.jungle,
      ...rest
    }: ButtonBaseProps,
    ref
  ) => (
    <ButtonBase
      ref={ref}
      className={cx(
        className,
        css`
          &.MuiButton-root {
            background: ${background} !important;
            color: ${rest.disabled ? colors.neutralAsh : fontColor} !important;
            text-transform: capitalize;
            text-decoration: underline !important;
          }
        `
      )}
      {...rest}
    >
      {children}
    </ButtonBase>
  )
);

export const ButtonFlatSmall = styled(ButtonFlat)(ButtonFlatSmallStyles);
export const ButtonFlatMedium = styled(ButtonFlat)(ButtonFlatMediumStyles);
export const ButtonFlatLarge = styled(ButtonFlat)(ButtonFlatLargeStyles);
export const ButtonFlatSmallEmphasized = styled(ButtonFlat)(ButtonFlatSmallEmphasizedStyles);
export const ButtonFlatMediumEmphasized = styled(ButtonFlat)(ButtonFlatMediumEmphasizedStyles);
